// export const domain = "http://127.0.0.1:8000/api/v1/driver";
export const domain = "https://tnl-api.ksta.co/api/v1/driver";
